export const STUDENT_PROGRESS = [
  {
    id: 78,
    created_at: 1691499908504,
    attendence_status: 'Regular',
    grade_avg: 24,
    homework_progress: 20,
    quiz_progress: 30,
    extra_help: 50,
    user_id: 274,
    grades_id: 0,
    classroom_id: ['6SNYdhsU', 'HMOcexAJ', 'bZFVG5sc', 'nps2h3wL'],
    user: {
      id: 274,
      created_at: 1691499908303,
      firstName: 'Merry',
      lastName: 'Code',
      email: 'code@student.com',
      school_indentity_number: '567777899988',
      role_id: 18,
      school_id: 47,
      isNewUser: false,
      profileData: {
        grades: 1,
        parentEmail: null,
        studentCode: null,
        currentRoute: '/administration',
      },
      teachingInfo: '',
      user_profile_media_id: 0,
      contact: 0,
      address: 'Test',
      birthdate: null,
      isDisable: false,
      is_logged_in: false,
      is_trial_user: null,
    },
    studentId: 78,
    points: [
      {
        type: 4,
        points: 30,
      },
      {
        type: 4,
        points: 30,
      },
    ],
    total_power_up_points: 60,
    powerUpPointsByAiLength: [],
    powerUpPointsByAi: 20,
    powerUpPointsByTeacherLength: [],
    powerUpPointsByTeacher: 40,
    powerUpPointsByStudentLength: [],
    powerUpPointsByStudent: 60,
    powerUpPoints: 60,
    quizProgress: 100,
    homeWorkProgress: 100,
    powerUpPointsByHelpingStudentLength: [
      {
        type: 4,
        points: 30,
      },
      {
        type: 4,
        points: 30,
      },
    ],
    pointsByHelpingStudents: 60,
  },

  {
    id: 79,
    created_at: 1691499908504,
    attendence_status: 'Regular',
    grade_avg: 0,
    homework_progress: 0,
    quiz_progress: 0,
    extra_help: 0,
    user_id: 275,
    grades_id: 0,
    classroom_id: ['bZFVG5sc', 'HMOcexAJ', '6SNYdhsU', 'nps2h3wL'],
    user: {
      id: 275,
      created_at: 1691499908303,
      firstName: 'Cody',
      lastName: 'Lesner',
      email: 'lesner@student.com',
      school_indentity_number: '567777899989',
      role_id: 18,
      school_id: 47,
      isNewUser: false,
      profileData: {
        grades: 1,
        parentEmail: null,
        studentCode: null,
        currentRoute: '/administration',
      },
      teachingInfo: '',
      user_profile_media_id: 0,
      contact: 0,
      address: 'America',
      birthdate: null,
      isDisable: false,
      is_logged_in: false,
      is_trial_user: null,
    },
    studentId: 79,
    total_power_up_points: 60,
    powerUpPointsByAi: 20,
    powerUpPointsByTeacher: 49,
    powerUpPointsByStudent: 60,
    pointsByHelpingStudents: 80,
    powerUpPoints: 0,
    quizProgress: 100,
  },

  {
    id: 574,
    created_at: 1695293824879,
    attendence_status: 'regular',
    grade_avg: 0,
    homework_progress: 0,
    quiz_progress: 0,
    extra_help: 0,
    user_id: 1392,
    grades_id: 7,
    classroom_id: ['bZFVG5sc', 'HMOcexAJ', '6SNYdhsU', 'nps2h3wL'],
    grades: {
      id: 7,
      created_at: 1667469798924,
      grade: '5th',
    },
    user: {
      id: 1392,
      created_at: 1695293824278,
      firstName: 'KaneOwens',
      lastName: 'Macullum',
      email: 'kaneow@student.com',
      school_indentity_number: '327482',
      role_id: 18,
      school_id: 47,
      isNewUser: false,
      profileData: {
        grades: 7,
        parentEmail: null,
        studentCode: 'Jn7QEM',
        currentRoute: '/administration',
      },
      teachingInfo: '',
      user_profile_media_id: 0,
      contact: 0,
      address: '',
      birthdate: null,
      isDisable: false,
      is_logged_in: false,
      is_trial_user: null,
    },
    studentId: 574,
    total_power_up_points: 60,
    powerUpPointsByAi: 40,
    powerUpPointsByTeacher: 50,
    powerUpPointsByStudent: 70,
    pointsByHelpingStudents: 80,
    powerUpPoints: 90,
    quizProgress: 100,
    homeWorkProgress: 100,
  },
];
